export function clusterPairAdminUrl(...clusterIds) {
  const ids = clusterIds.filter(Boolean).map(String);
  const filters = JSON.stringify({ _id: { $in: ids } });
  return `/legos/image-clusters?filters=${encodeURIComponent(filters)}`;
}

/** /processed/.../{s|m|l}/file → /originals/.../file */
export function toOriginalImageUrl(imgUrl) {
  imgUrl = imgUrl || '';
  if (!imgUrl || imgUrl.includes('/originals/')) return imgUrl;
  return imgUrl.replace(/\/processed\/((?:[^/]+\/)+)([sml])\/([^/]+)$/i, '/originals/$1$3');
}

export const FAIL_TYPE_HELP = {
  false_same: 'different clusters, but similarity is above the threshold (false positive)',
  false_different: 'same cluster, but similarity is below the threshold (false negative)',
  missed_match: 'image actually joined an existing cluster, but the model said "new cluster"',
  false_match: 'image actually founded a new cluster, but the model matched an existing one',
  wrong_cluster: 'model correctly said "join existing" but picked an unrelated cluster',
};
